export const smallScreen = window.outerWidth < 500;
export const mediumScreen = window.outerWidth >= 500 && window.outerWidth <= 800;
export const largeScreen = window.outerWidth > 800;
